import React, { useState, useEffect } from 'react';
import '../../urunDiv.css';
import '../icecekler/sicak-kahveler/KahveDetay.css';
import patatesTabagi from '../../../assets/menu/yemekler/dostluk-pekistirenler/patates-tabagi.png';

const PatatesTabagi = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const yemek = {
    name: 'Patates Tabağı',
    price: '₺349,90',
    image: patatesTabagi,
    description: 'Çıtır çıtır kızartılmış altın sarısı patates dilimleri. Özel baharatlarla tatlandırılmış, yanında ketçap ve mayonez ile servis edilir. Atıştırmalık olarak ideal.'
  };

  return (
    isPhone ? (
      <div className="americano-detay-container">
        {/* Product Section */}
        <div className="product-section">
          <div className="product-image-container">
            <img src={yemek.image} alt={yemek.name} className="product-image" />
            <div className="product-overlay">
              <div className="product-name-price">{yemek.name} - {yemek.price}</div>
            </div>
          </div>
          
          <div className="product-description">
            <p>{yemek.description}</p>
          </div>
        </div>
      </div>
    ) : (
      <div className="urun-detay-container-computer">
        {/* Product Section */}
        <div className="product-section">
          <div className="product-image-container">
            <img src={yemek.image} alt={yemek.name} className="product-image" />
            <div className="product-overlay">
              <div className="product-name-price">{yemek.name} - {yemek.price}</div>
            </div>
          </div>
          
          <div className="product-description-computer">
            <p>{yemek.description}</p>
          </div>
        </div>
      </div>
    )
  );
};

export default PatatesTabagi;
